import Helmet from "react-helmet";
import { Outlet, Route } from "react-router";
import styled, { createGlobalStyle } from "styled-components";

import Brands from "./app/Brands";
import Pricelist from "./app/Pricelist";
import PricelistNew from "./app/PricelistNew";
import Pricelists from "./app/Pricelists";
import AppHeader from "../../components/AppHeader";
import {
    useUnsavedChangesRefs,
    type UnsavedChangesContext,
} from "../../modules/unsaved-changes";

const GlobalStyle = createGlobalStyle`
    :root {}
`;

const Styled = styled.div`
    display: grid;
    grid-template-columns: 1fr minmax(0, 1fr) 2fr;
    gap: 4vw;
    padding: 128px 128px 64px 192px;

    & > *:not(:last-child):not(:hover):not(:has(input:focus)) {
        opacity: 0.4;
    }
`;

export type PriceListAppOutletContext = UnsavedChangesContext;

function App() {
    const guard = useUnsavedChangesRefs();

    return (
        <>
            <Helmet>
                <title>PriceLists</title>
            </Helmet>
            <GlobalStyle />
            <AppHeader title="pricelists" guard={ guard } />
            <Styled>
                <Outlet context={ guard satisfies PriceListAppOutletContext } />
            </Styled>
        </>
    );
}

export default (
    <Route Component={App} path="pricelists">
        <Route Component={Brands}>
            <Route index />
            <Route Component={Pricelists} path=":brandID">
                <Route index />
                <Route Component={PricelistNew} path="new" />
                <Route Component={Pricelist} path=":pricelistID" />
            </Route>
        </Route>
    </Route>
);
